var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    button__group: true,
    'button__group--vertical': _vm.vertical,
    'button__group--vertical-reverse': _vm.reverse,
  }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }